<template>
    <div class="header" :style="$bgColor(color.primary)">
        <div class="container">
            <div class="header-body">
                <slot name="navigation"></slot>
                <div class="card px-3 py-3 my-2">
                    <div class="d-flex justify-content-around align-items-center">
                        <div class="flex flex-grow-1" v-if="exercise.translation">
                            <h1 class="mb-0">{{exercise.translation.title}}</h1>
                        </div>
                        <!-- Timer -->
                        <ExerciseTimer v-if="exercise.time" />
                        <!-- Certificado -->
                        <div v-if="certificateCondition()">
                            <div class="col-12 mb-1 mx-2">
                                <certificate-link
                                    :certificate="certificateToUse"
                                    :relation="{type: 'exercise', id: exercise.id}"
                                    dark
                                    minimal
                                ></certificate-link>
                            </div>
                        </div>
                        <div v-else-if="this.certificate && this.exercise.progress">
                            <div class="col-12 mb-1 mx-2">
                                <div
                                    :data-toggle="'tooltip'"
                                    :title="$t('certificate.progress', {
                                        certificateProgress: this.certificate.progress,
                                        studentProgress: this.exercise.grade_percentage,
                                    })"   
                                    data-trigger="hover focus"
                                >
                                    <i
                                        class="mdi mdi-36px mdi-trophy certificate__trophy"
                                        :style="{color: 'red'}"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Barra de progresso -->
                    <ProgressBar
                        class=" mt-2 mb-0"
                        :exercise-id="exercise.id"
                        v-if="exerciseProgress && exercise.id"
                        no-shadow
                    />
                </div>
                <TimerConfirmation v-if="exercise.time" />
            </div>
        </div>
    </div>
</template>

<script>
import ProgressBar from '../Common/ProgressBar';
import CertificateLink from '../Certificate/CertificateLink';
import TimerConfirmation from './ExerciseTimerConfirmation';
import ExerciseTimer from './ExerciseTimer';

export default {

    name: 'ExerciseHeader',

    components: {
        ProgressBar,
        CertificateLink,
        TimerConfirmation,
        ExerciseTimer,
    },

    props: {
        certificate: {
            type: Object,
        },
        exerciseProgress: Boolean,
    },

    data() {
        return {
            invalidCertificate: false,
        };
    },

    methods: {
        certificateCondition() {
            if (this.exercise && this.certificateToUse) {
                if ((this.certificate && this.exercise.progress && this.exercise.grade_percentage >= this.certificate.progress) || Number(this.exercise.grade_percentage) >= Number(this.certificateToUse.progress)) {
                    return true;
                }
            } else {
                return false;
            }
        },

        certificateConditionProgress() {
            if (this.exercise && this.certificateToUse) {
                if (Number(this.exercise.grade_percentage) < Number(this.certificateToUse.progress)) {
                    return true;
                }
            } else {
                return false;
            }
        }
    },

    computed: {
        exercise() {
            return this.$store.getters.LOADED_EXERCISE;
        },
        color() {
            return this.$store.getters.COLOR;
        },
        started() {
            return this.$store.getters.LOADED_EXERCISE.started;
        },
        finished() {
            return this.$store.getters.LOADED_EXERCISE.finished;
        },
        certificateToUse() {
            let certificateValue = false;
            const certificates = this.$store.getters.LOADED_EXERCISE_HEADER_CERTIFICATE;
            if (this.exercise.finished === true || this.exercise.finished === 1) {
                if (this.certificate !== undefined) {
                    this.invalidCertificate = false;
                    certificateValue = this.certificate;
                    return certificateValue;
                } else {
                    const matchingCertificate = certificates.find(cert =>
                        cert && cert.code.relation_id === this.exercise.id);

                    if (matchingCertificate) {
                        const matchingCertificateProgress = parseInt(matchingCertificate.progress, 10);
                        certificateValue = matchingCertificate;
                        if (this.exercise.grade >= matchingCertificateProgress) {
                            this.invalidCertificate = false;
                            return certificateValue;
                        } else {
                            this.invalidCertificate = true;
                            return certificateValue;
                        }
                    } else if (matchingCertificate == null){
                        this.invalidCertificate = true;
                        return certificateValue;
                    }
                }
            }
            this.invalidCertificate = false;
            return certificateValue;
        },
    },
};
</script>

<style scoped>
    .certificate__trophy {
        position: relative;
    }
</style>
